import { render } from "./ReviewDashboard.vue?vue&type=template&id=3bfc996c"
import script from "./ReviewDashboard.vue?vue&type=script&lang=js"
export * from "./ReviewDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__